import { useEffect, useState } from "react";
import { makeRequest } from "../makeRequest";

const useFetch = (url, metaIncluded = false) => {
  const [data, setData] = useState(null);
  const [meta, setMeta] = useState(null)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!url) {
  setLoading(false);
  return;
}
    // if(!url) return
    // Abort the previous request so a slow response for an old url can never
    // overwrite the data of a newer one.
    const controller = new AbortController();
    let active = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        // Never let consumers read the previous url's payload while the new
        // request is still in flight.
        setData(null);
        setMeta(null);
        setError(false);

        // const res = await makeRequest.get(url, { signal: controller.signal });
        const res = await makeRequest.get(url, { signal: controller.signal, timeout: 20000 });
        if (!active) return;
        setData(res.data.data);
        setMeta(res.data.meta)
      } catch (err) {
        if (!active || controller.signal.aborted) return;
        setError(true);
      }
      if (active) setLoading(false);
    };
    fetchData();

    return () => {
      active = false;
      controller.abort();
    };
  }, [url]);

  return metaIncluded ? { data, loading, error, meta } : { data, loading, error };
};

export default useFetch;